"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDraggableList = void 0;
var react_1 = __importStar(require("react"));
var react_beautiful_dnd_1 = require("react-beautiful-dnd");
var DraggableItem_1 = __importDefault(require("./components/DraggableItem"));
var helpers_1 = require("./helpers");
var DroppableZone_1 = __importDefault(require("./components/DroppableZone"));
var DraggableListContext = react_1.createContext({
    direction: "vertical",
    grid: 0,
});
DraggableListContext.displayName = "DraggableListContext";
function useDraggableList() {
    return react_1.useContext(DraggableListContext);
}
exports.useDraggableList = useDraggableList;
function DraggableList(_a) {
    var items = _a.items, setItems = _a.setItems, _b = _a.direction, direction = _b === void 0 ? "vertical" : _b, _c = _a.inPortal, inPortal = _c === void 0 ? false : _c, _d = _a.grid, grid = _d === void 0 ? 0 : _d, onDropExternal = _a.onDrop, children = _a.children;
    function onDrop(result) {
        if (!result.destination) {
            return;
        }
        var orderedItems = helpers_1.reorderDndItems(items, result.source.index, result.destination.index);
        setItems(orderedItems);
        onDropExternal && onDropExternal(orderedItems);
    }
    return (react_1.default.createElement(DraggableListContext.Provider, { value: { direction: direction, inPortal: inPortal, grid: grid } },
        react_1.default.createElement(react_beautiful_dnd_1.DragDropContext, { onDragEnd: onDrop }, children)));
}
exports.default = DraggableList;
DraggableList.Item = DraggableItem_1.default;
DraggableList.Dropzone = DroppableZone_1.default;
//# sourceMappingURL=index.js.map